import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { BsGearFill, BsDatabaseFill, BsExclamationCircleFill } from 'react-icons/bs';
import ProductionSummaryModal from "./ProductionSummaryMadal";
import { TrendingUp } from 'react-feather';
import Production from './Production';
import MachinesManpower from './MachinesManpower';
import RowMaterials from './RowMaterials';
import QualityNc from './QualityNc';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
const SupervisorDashboard = () => {
  const [activeTab, setActiveTab] = useState('Production');
  const [showModal, setShowModal] = useState(false);
  const [dailyProduction, setDailyProduction] = useState([])
  const [machineUtilization, setMachineUtilization] = useState([])
  const [materialStaus, setMaterialStaus] = useState([])
  const [qualityIssue, setQualityIssue] = useState([])
  useEffect(() => {
    fetchDailyProduction();
    fetchMachineUtilization();
    fetchMaterialStaus()
    fetchQualityIssue()
  }, []);
  const fetchDailyProduction = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/supervisor/dashboard/dailyproduction`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setDailyProduction(response?.data || []);
      } else {
        setDailyProduction([]);
      }
    } catch (err) {
      console.error("Error fetching fetchDailyProduction:", err.message);
    }
  };
  const fetchMachineUtilization = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/supervisor/dashboard/MachineUtilization`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data || {};
      setMachineUtilization(result)
    } catch (err) {
      console.error("Error fetching MachineUtilization:", err.message);
    }
  };

  const fetchMaterialStaus = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/supervisor/dashboard/MaterialStaus`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data || {};
      setMaterialStaus(result)
    } catch (err) {
      console.error("Error fetching fetchMaterialStaus:", err.message);
    }
  };

  const fetchQualityIssue = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/supervisor/dashboard/QualityIssue`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data || {};
      setQualityIssue(result)
    } catch (err) {
      console.error("Error fetching fetchMaterialStaus:", err.message);
    }
  };
  const renderContent = () => {
    switch (activeTab) {
      case 'Production':
        return <Production />;
      case 'Machines Manpower':
        return <MachinesManpower />;
      case 'Raw Materials':
        return <RowMaterials />;
      case 'Quality Nc':
        return <QualityNc />;
      default:
        return <Production />;
    }
  };

  const metrics = [
    {
      title: "Daily Production",
      value: dailyProduction?.percentage
        ? `${Number(dailyProduction?.percentage).toFixed(2)}%`
        : "0",
      subtitle: "Daily Production Target",
      icon: (
        <div
          style={{
            backgroundColor: '#e0ebff',
            borderRadius: '50%',
            padding: '10px',
            width: 'fit-content',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <TrendingUp color="#1D4ED8" size={18} />
        </div>
      )
    },
    {
      title: "Machine Utilization",
      value: machineUtilization?.utlization
        ? `${Number(machineUtilization?.utlization).toFixed(2)}%`
        : "0",
      subtitle: machineUtilization?.activeMachines && machineUtilization?.totalMachines
        ? `${machineUtilization?.activeMachines}/${machineUtilization?.totalMachines} machines active`
        : "0",
      icon: (
        <div
          style={{
            backgroundColor: '#b0f0d8ff',
            borderRadius: '50%',
            padding: '10px',
            width: 'fit-content',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <BsGearFill color="#0c7549ff" size={18} />
        </div>
      )
    },
    {
      title: "Material Status",
      value: materialStaus?.materials
        ? `${materialStaus.materials}`
        : "0",
      subtitle: "No Shortages",
      icon: (
        <div
          style={{
            backgroundColor: '#b0f0d8ff',
            borderRadius: '50%',
            padding: '10px',
            width: 'fit-content',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <BsDatabaseFill color="#0c7549ff" size={18} />
        </div>
      )
    },

    {
      title: "Quality Checks",
      value: qualityIssue?.quality_issues !== undefined && qualityIssue?.quality_issues !== null
        ? `${qualityIssue?.quality_issues}`
        : "-",
      subtitle: "requires attention",
      icon: (
        <div
          style={{
            backgroundColor: '#fff4c2',
            borderRadius: '50%',
            padding: '10px',
            width: 'fit-content',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <BsExclamationCircleFill color="#8B2500" size={18} />
        </div>
      )
    }
  ];


  return (
    <div className="container-fluid p-4" style={{ background: "#EEF2F8" }}>
      <div className="row font_family">
        <div className="col-lg-1" />
        <div className="col-lg-10">
          <div className="row">
            {/* Header */}
            <div className="row align-items-center mb-4">
              <div className="col-12 col-md-6">
                <strong className='ms-3 fs-4'>Supervisor Dashboard</strong>
              </div>
              <div className="col-12 col-md-6 text-md-end mt-3 mt-md-0">
                <div className='bg-info d-inline-block px-2 py-1 rounded'>
                  Current Shift : {dailyProduction?.shift}
                </div>
                 {" "}
              </div>
            </div>

            {/* Metric Cards */}
            <div className="row mb-4 ms-1">
              {metrics.map((metric, idx) => (
                <div
                  className="col-12 col-sm-6 col-md-3 mb-3"
                  key={idx}
                  onClick={() => {
                    if (metric.title === "Daily Production") {
                      setShowModal(true);
                    }
                  }}
                  style={{ cursor: metric.title === "Daily Production" ? 'pointer' : 'default' }}
                >
                  <Card border={metric.color} className="w-100 h-100">
                    <Card.Body>
                      <Card.Title>{metric.title}</Card.Title>
                      <h4 className="fw-bold d-flex justify-content-between align-items-center">
                        {metric.value}
                        <span>{metric.icon}</span>
                      </h4>
                      <small>{metric.subtitle}</small>
                    </Card.Body>
                  </Card>
                </div>
              ))}


              {/* Tabs */}
              <div className=" row rounded text-dark px-2 py-1 font_family mt-4 py-1 m-1" style={{ background: "#e0e9fbff" }}>
                <div className='col-md-3'><TabItem label="Production" active={activeTab === 'Production'} onClick={() => setActiveTab('Production')} /></div>
                <div className='col-md-3'><TabItem label="Machines  & Manpower" active={activeTab === 'Machines Manpower'} onClick={() => setActiveTab('Machines Manpower')} /></div>
                <div className='col-md-3'><TabItem label="Raw Materials" active={activeTab === 'Raw Materials'} onClick={() => setActiveTab('Raw Materials')} /></div>
                <div className='col-md-3'><TabItem label="Quality & Nc" active={activeTab === 'Quality Nc'} onClick={() => setActiveTab('Quality Nc')} /></div>
              </div>
            </div>
            <ProductionSummaryModal
              show={showModal}
              onHide={() => setShowModal(false)}
            />
            <div className="mt-1">
              {renderContent()}
            </div>
          </div>
        </div>
        <div className="col-lg-1" />
      </div>
    </div>
  );
};

function TabItem({ label, icon, active, onClick }) {
  return (
    <div
      className={`flex-fill text-center py-2 rounded d-flex align-items-center justify-content-center gap-2 ${active ? 'bg-light text-dark fw-bold' : ''
        }`}
      style={{ cursor: 'pointer' }}
      onClick={onClick}
    >
      {icon}
      <span>{label}</span>
    </div>
  );
}

export default SupervisorDashboard;
